<template>
  <div class="drugs">
    <div class="drugs_ul">
      <div
        class="drugs_li"
        v-for="(item, index) in dataArr"
        :key="index"
        @click="todetail(item)"
      >
        <img :src="'/static/images/'+item.id+'.jpg'" alt="" />
        <p>{{ item.name }}</p>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        @prev-click="handlePre"
        @next-click="handleNext"
        @current-change="changePage"
        :current-page="current_page"
        background
        layout="prev, pager, next"
        :page-count="total_page"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      total_page: 0,
      current_page: 1,
      page_size: 36,
      dataArr: [],
      jsondata:[]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $.ajax({
        url:"/static/json/bencao/list.json",
        type:'GET',
        success:(res)=>{
          this.jsondata = res
          let length = res.length;
          // console.log(length);
          this.total_page = Math.ceil(length / 36);
          // console.log(this.total_page);
          this.dataArr = res.slice(0, 36);
        }
      })
    },
    todetail(item) {
      // console.log(item);
      this.$router.push({
        path: "/detail",
        query: {
          did: item.id,
          name: item.name
        }
      });
    },
    handlePre(val) {
      this.current_page = val;
      let star = (this.current_page - 1) * 36;
      let end = star + 36;
      this.dataArr = this.jsondata.slice(star, end);
    },
    // 点击下一页
    handleNext(val) {
      this.current_page = val;
      let star = (this.current_page - 1) * 36;
      let end = star + 36;
      this.dataArr = this.jsondata.slice(star, end);
    },
    changePage(val) {
      this.current_page = val;
      let star = (this.current_page - 1) * 36;
      let end = star + 36;
      this.dataArr = this.jsondata.slice(star, end);
    },
  },
};
</script>
<style lang="scss" scoped>
.drugs {
  width: 1200px;
  margin: 0 auto;
  .drugs_ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;
    margin-bottom: 30px;
    justify-content: space-around;
    border: 1px solid #936e2c;
    .drugs_li {
      width: 180px;
      height: 257px;
      cursor: pointer;
      img {
        width: 180px;
        height: 230px;
      }
      p {
        text-align: center;
        border: 1px solid #936e2c;
      }
    }
  }
}
</style>